import { vanessaDad } from './../characters/VanessaDad';
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { mc } from "../characters/MC";
import { images } from "./images";
import { vanessa } from '../characters/Vanessa';
import Game from '../../src/shell/Game';
import { empty } from '../characters/empty';
import { V5HomeAfterVanessaHome } from './V5';
import { doTransition } from '../helpers/helpers';

export const V5VanessaHouseMorningVanessasFatherConversation = async (): Promise<any> => {
    doTransition(images.v5.VanessaFrontDoor_0);
    mc.think(`Vanessa's house...`);
    mc.think(`It always surprises me how calm her house looks compared to how bat shit crazy she is.`);
    if (mc.properties.joeStatus === "enemy") {

        mc.think(`I wonder if she is still pissed at me...`);
    }
    mc.think(`Time to get inside, her front door is usually open.`);
    ImageClass.setImage(images.v5.VanessaFrontDoor_1);
    mc.talk(`Oh... Hey.`);
    mc.think(`Shit, is that her father?`);
    mc.think(`I've never ran into him. I hope it's not going to be awkward...`);
    vanessaDad.talk(`I've donated at work.`);
    mc.talk(`I didn't come to ask for money.`);
    ImageClass.setImage(images.v5.VanessaFrontDoor_1);
    vanessaDad.talk(`...`);
    mc.talk(`I came to see Vanessa.`);
    ImageClass.setImage(images.v5.VanessaFrontDoor_3);
    vanessaDad.talk(`YOU? Came to see MY daughter?`);
    mc.talk(`Yes...?`);
    if (mc.properties.joeStatus === "enemy") {

        mc.talk(`I came to return her phone.`);
        vanessaDad.talk(`Not possible, she never loses stuff.`);
        mc.talk(`She did this time.`);
        vanessaDad.talk(`Since I'm in a hurry, I'll give you the benefit of the doubt.`);
    } else {
        mc.talk(`I came to talk to her.`);
        vanessaDad.talk(`Oh, really? What do you plan to talk about?`);
        mc.talk(`Ah... Stuff?`);
        vanessaDad.talk(`Talk about stuff.`);
        vanessaDad.talk(`I know what boys your age have on their minds.`);
        mc.talk(`Me too.`);
        vanessaDad.talk(`Are you a funny guy?`);
        mc.talk(`No sir.`);
    }
    ImageClass.setImage(images.v5.VanessaFrontDoor_2);
    vanessaDad.talk(`You have my permission, do it quick, in and out.`);
    mc.think(`Phrasing...`);
    mc.talk(`Alright.`);
    vanessaDad.talk(`And no funny business, you hear?`);
    mc.talk(`Got it.`);
    if (mc.properties.joeStatus === "enemy") {

        return jump(V5VanessaHouseMorningVanessasFather6ConversationAfter, "V5VanessaHouseMorningVanessasFather6ConversationAfter");
    } else {
        return jump(V5VanessaHouseMorningJoeStatusNot6_2, "V5VanessaHouseMorningJoeStatusNot6_2");
    }

};


export const V5VanessaHouseMorningVanessasFather6ConversationAfter = async (): Promise<any> => {


    ImageClass.setImage(images.v5.VanessaRoom_34, { transition: true });
    vanessa.talk(`${mc.name}? What are you doing here?`);
    ImageClass.setImage(images.v5.VanessaRoom_35_2);
    vanessa.talk(`Quickly close the door!`);
    ImageClass.setImage(images.v5.VanessaRoom_36_2, { wait: true });
    ImageClass.setImage(images.v5.VanessaRoom_33);
    vanessa.talk(`Who let you inside?`);
    mc.talk(`Your father.`);
    vanessa.talk(`MY FATHER?!`);
    vanessa.talk(`This morning is just getting better and better.`);
    vanessa.talk(`What are you doing here anyway?`);
    mc.talk(`I woke up this morning and...`);
    ImageClass.setImage(images.v5.VanessaRoom_30);
    vanessa.talk(`Uh-huh.`);
    mc.talk(`What are you doing?`);
    vanessa.talk(`Continue, I'm listening.`);
    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {

        mc.talk(`After I left the bar...`);
    } else {

        mc.talk(`After I put you to bed I went back to the bar...`);
    }

    vanessa.talk(`Uh-huh.`);
    ImageClass.setImage(images.v5.VanessaRoom_35);

    await vanessa.setQuestion(new Question({ text: `Where the fuck is it?`, options: { think: false, method: "Mumbling Quietly" }, key: `v5LetVanessaSearchHerPhone` })
        .option({ title: `Give her the phone`, key: false })
        .option({ title: `Let her search`, key: true }));


    if (Question.globalAnswers.v5LetVanessaSearchHerPhone) {
        return jump(V5VanessaHouseMorningJoeStatus6LetHerSearch, "V5VanessaHouseMorningJoeStatus6LetHerSearch");

    } else {
        return jump(V5VanessaHouseMorningJoeStatus6GivePhone, "V5VanessaHouseMorningJoeStatus6GivePhone");

    }

};

export const V5VanessaHouseMorningJoeStatus6LetHerSearch = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_35);

    mc.talk(`I wanted to check up with you.`);
    ImageClass.setImage(images.v5.VanessaRoom_39);
    vanessa.talk(`I barely remember anything from yesterday, but yeah, I am fine.`);
    mc.talk(`You don't look like you have a hangover.`);
    vanessa.talk(`Two aspirins in the morning is the trick.`);
    ImageClass.setImage(images.v5.VanessaRoom_35);
    vanessa.talk(`It's not there... Where the fuck did I put it?`, { method: "Mumbling Quietly" });
    ImageClass.setImage(images.v5.VanessaRoom_31);
    vanessa.talk(`So, if you came to check up on me, I'm fine.`);
    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {
        ImageClass.setImage(images.v5.VanessaRoom_32);
        vanessa.talk(`Oh shit, did you do a body shot off me?`);
        mc.talk(`Well... You were convincing.`);
        vanessa.talk(`Pervert.`);
        mc.talk(`Me and everyone else at the bar.`);
        vanessa.talk(`Shit, I can't believe that happened again.`);
        mc.talk(`Again?!`);
    } else if (Question.globalAnswers.v4VanessaDrunkDidBodyShot === false) {
        vanessa.talk(`Good thing, Joe still cares about me.`);


    }

    vanessa.talk(`Maybe it's under the pillow.`, { method: "Mumbling Quickly" });
    ImageClass.setImage(images.v5.VanessaRoom_32);
    vanessa.talk(`SHIT!`);
    mc.talk(`That's a big ass pillow.`);
    ImageClass.setImage(images.v5.VanessaRoom_40);
    vanessa.talk(`Remind me, why are you here again?`);
    ImageClass.setImage(images.v5.VanessaRoom_51);
    mc.talk(`To give you your phone.`);
    vanessa.talk(`Did you have it all this time?`);
    vanessa.talk(`Give it!`);
    ImageClass.setImage(images.v5.VanessaRoom_38);
    vanessa.talk(`Did you really want to talk? Or you just like watching me crawling on my knees?`);
    mc.talk(`Mmm... Both?`);
    vanessa.talk(`Well... Thank you, I have some important stuff in there that I didn't want to lose.`);
    vanessa.talk(`Why did you have it anyway?`);
    return jump(V5VanessaHouseMorningJoeStatus6_2, "V5VanessaHouseMorningJoeStatus6_2");


};


export const V5VanessaHouseMorningJoeStatus6GivePhone = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_35);
    mc.talk(`Vanessa.`);
    ImageClass.setImage(images.v5.VanessaRoom_39);
    vanessa.talk(`What?`);
    mc.talk(`I have your phone, if that's what you are looking for.`);
    ImageClass.setImage(images.v5.VanessaRoom_33);
    vanessa.talk(`Oh my God! Why didn't you say so sooner???`);
    mc.talk(`You didn't let me talk.`);
    ImageClass.setImage(images.v5.VanessaRoom_36);
    mc.talk(`Here it is.`);
    ImageClass.setImage(images.v5.VanessaRoom_37);



    vanessa.talk(`Well... Thank you, I have some important stuff in there that I didn't want to lose.`);
    vanessa.talk(`Why did you have it anyway?`);
    mc.talk(`That's what I was trying to tell you.`);
    vanessa.talk(`Fine, let's sit down.`);

    return jump(V5VanessaHouseMorningJoeStatus6_2, "V5VanessaHouseMorningJoeStatus6_2");
};

export const V5VanessaHouseMorningJoeStatus6_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_38);


    mc.talk(`I got it from the bar after you dropped it there.`);

    mc.talk(`You really don't remember anything from yesterday?`);
    vanessa.talk(`I remember bits and pieces.`);
    vanessa.talk(`I know I was fucking angry at you.`);
    mc.talk(`Was?`);
    vanessa.talk(`I still am, but less.`);
    mc.talk(`What changed?`);
    vanessa.talk(`I had some time to think.`);
    vanessa.talk(`And I can't ignore the fact that I played a huge part in what happened.`);
    vanessa.talk(`I kept teasing you for fun, and when you saw me with Chris that idea popped into my head.`);
    mc.talk(`Vanessa are you really taking responsibility?`);
    ImageClass.setImage(images.v5.VanessaRoom_41);
    vanessa.talk(`No, I still think you are a moron.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Don't get me wrong, we wouldn't be in this mess if you just kept your mouth shut.`);
    mc.talk(`Fair enough...`);
    mc.talk(`So wait, why Chris though?`);

    if (Game.seenScenarios.includes(`ClubEventWithoutJoeInsideGoToVanessaStay`)) {
        mc.talk(`And that big guy from yesterday?`);
        ImageClass.setImage(images.v5.VanessaRoom_49);
        vanessa.talk(`Oh shit, I do remember a tiny dick.`);
        ImageClass.setImage(images.v5.VanessaRoom_50);
        vanessa.talk(`Well. I didn't plan it beforehand.`);
        mc.talk(`What did you want to achieve anyway?`);
        mc.talk(`All this mess started with a blowjob, why did you think a blowjob would end it?`);
        vanessa.talk(`What's with all these questions in the morning? I am not even fully awake!`);
        vanessa.talk(`I knew you wanted a blowjob so much, so I tried to aggravate you.`);
        vanessa.talk(`Obviously it didn't work because you are here.`);
        vanessa.talk(`And about Chris.`);
    }
    ImageClass.setImage(images.v5.VanessaRoom_49);
    vanessa.talk(`That was just me being me...`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`When Joe and I were first starting going out, I warned him. I told him I'm not relationship material.`);
    vanessa.talk(`But he insisted that we try.`);
    vanessa.talk(`That's why he hasn't given up yet.\nHe knew what he is getting into.`);
    mc.talk(`That you are a...`);
    vanessa.talk(`Slut?`);
    vanessa.talk(`And you are a man-whore.`);
    vanessa.talk(`I just like sex, what's wrong with that?`);
    vanessa.talk(`I am still young and hot. I want to try different dicks before my boobs drop to my knees.`);
    vanessa.talk(`Do you know how many old women I've met that told me that are sorry they didn't try more things when they were young?`);
    vanessa.talk(`I know it ruins my reputation and that there are rumors about me that I'm easy to get.`);
    vanessa.talk(`But fuck all of them! I'll do what I want.`);
    mc.talk(`I understand.`);
    mc.talk(`People usually think about the present, and they don't want a bad name for themselves.`);
    vanessa.talk(`Because they can't handle people gossiping and staring.`);
    vanessa.talk(`Once they see you don't care, you are no longer interesting.`);

    mc.talk(`You are pretty smart. I've never seen that side of you before.`);
    ImageClass.setImage(images.v5.VanessaRoom_48);
    vanessa.talk(`Do you really think I'm pretty???`);
    mc.talk(`... Pretty smart...`);
    vanessa.talk(`Haha.`);

    return jump(V5VanessaHouseMorningJoeStatus6_3, "V5VanessaHouseMorningJoeStatus6_3");

};

export const V5VanessaHouseMorningJoeStatus6_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_50);
    mc.talk(`So, what happened after I left the bar?`);
    vanessa.talk(`I told you, I don't remember much.`);
    vanessa.talk(`I remember lying naked on the bar counter, but I don't remember why I decided to do it.`);

    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot === false) {
        vanessa.talk(`But I do remember that you came and carried me home.`);
        vanessa.talk(`Wait! Why didn't you give me that phone once we got here?`);
        mc.talk(`I didn't have it at that point.`);
        mc.talk(`I went back after I dropped you here to get it.`);
        ImageClass.setImage(images.v5.VanessaRoom_42);
        vanessa.talk(`Ewww... That's so sweet of you.`);
        ImageClass.setImage(images.v5.VanessaRoom_43);
        vanessa.talk(`I hope you didn't snoop in it!`);
        ImageClass.setImage(images.v5.VanessaRoom_42);
        if (mc.properties.liar > 5) {
            mc.talk(`No, never.`);
            vanessa.talk(`Good.`);
        } else {
            mc.talk(`I tried, but the battery was dead and I don't have the right charger.`);
            vanessa.talk(`At least you are honest.`);
        }

        vanessa.talk(`Anyway, I have a plan.`);
    } else {
        vanessa.talk(`But I do remember Joe carrying me home.`);
        vanessa.talk(`Oh shit, it's coming back to me now.`);
        if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {
            if (!Game.seenScenarios.includes(`V5VanessaHouseMorningJoeStatus6LetHerSearch`)) {
                vanessa.talk(`Oh shit, did you do a body shot off me?`);
                mc.talk(`Well... You were convincing.`);
                vanessa.talk(`Pervert.`);
                mc.talk(`Me and everyone else at the bar.`);
                vanessa.talk(`Shit, I can't believe that happened again.`);
                mc.talk(`Again?!`);
                vanessa.talk(`Yes, again.`);
                mc.talk(`Tell me more.`);
                vanessa.talk(`I got drunk and people did body shots off me. THE END.`);
                mc.talk(`Great story.`);
                vanessa.talk(`I know right!`);
                mc.talk(`By the way, you said you don't care about these things, but you seem to care now.`);
                vanessa.talk(`Only because I don't remember.`);
            } else {
                vanessa.talk(`You fucked up again!`);
            }

        }

        vanessa.talk(`You are lucky Joe didn't kill you.`);
        mc.talk(`He is not violent.`);
        vanessa.talk(`Anyway, I have a plan.`);
    }

    mc.talk(`What plan?`);
    vanessa.talk(`To make Joe forgive you.`);
    mc.talk(`You would need to be a magician for that to happen.`);
    vanessa.talk(`Well, I have something in mind, but I just woke up, I need more time to think.`);
    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {

        ImageClass.setImage(images.v5.VanessaRoom_42);
        vanessa.talk(`Thanks again for bringing me my phone.`);
    }
    ImageClass.setImage(images.v5.VanessaRoom_44);
    vanessa.talk(`I need to get dressed.\nYou can leave now.`);
    mc.talk(`Aren't you afraid your father might see me again?`);
    vanessa.talk(`He left already, the house is empty.`);
    mc.talk(`Bye Vanessa.`);

    return jump(V5VanessaHouseMorningJoeStatus6_4, "V5VanessaHouseMorningJoeStatus6_4");
};

export const V5VanessaHouseMorningJoeStatusNot6_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_47, { transition: true });
    mc.think(`Time to talk to Vanessa.`);
    ImageClass.setImage(images.v5.VanessaRoom_34);
    vanessa.talk(`${mc.name}? What are you doing here?`);
    mc.talk(`Damn, nice PJs Vanessa.`);
    ImageClass.setImage(images.v5.VanessaRoom_35_2);
    vanessa.talk(`Quickly close the door!`);
    ImageClass.setImage(images.v5.VanessaRoom_36_2, { wait: true });
    ImageClass.setImage(images.v5.VanessaRoom_33);
    vanessa.talk(`Who let you inside?`);
    mc.talk(`Your father.`);
    vanessa.talk(`MY FATHER?!`);
    vanessa.talk(`Since you are still alive he must be planning to kill you on your way out.`);
    mc.talk(`He doesn't look that bad.`);
    vanessa.talk(`Pff... Whatever.`);
    vanessa.talk(`What are you doing here anyway?`);
    ImageClass.setImage(images.v5.VanessaRoom_37_2);
    vanessa.talk(`You must have missed me because it hasn't been even ten hours.`);
    if (mc.properties.annStatus === "hate") {

        return jump(V5VanessaHouseMorningJoeStatusNot6_2_Hate, "V5VanessaHouseMorningJoeStatusNot6_2_Hate");
    }

    mc.talk(`I actually came because I need your advice.`);
    vanessa.talk(`Oh really? Let's sit down!`);
    ImageClass.setImage(images.v5.VanessaRoom_50, { transition: true });
    vanessa.talk(`What is it? Talk! Now!`);

    mc.talk(`Alright.`);
    mc.talk(`Ann and I were talking...`);

    ImageClass.setImage(images.v5.VanessaRoom_48);
    vanessa.talk(`This morning???`);
    mc.talk(`Yes.`);
    vanessa.talk(`Where?`);
    mc.talk(`At my place.`);
    vanessa.talk(`Did she stay the night? Did you fuck???`);
    mc.talk(`Not yet.`);
    ImageClass.setImage(images.v5.VanessaRoom_49);
    vanessa.talk(`It's obviously not gonna happen so I'll just stop asking.`);
    mc.talk(`Well, actually, that's why I came.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);

    vanessa.talk(`Oh no, don't tell me she can't get your dick hard.`);
    if (mc.properties.alpha >= 5) {
        mc.talk(`Can you shut up for a minute?`);
        ImageClass.setImage(images.v5.VanessaRoom_38);
        vanessa.talk(`Ohh... Is that you ${mc.name}? Growing some balls?`);
        mc.talk(`I'm trying to talk, but you keep interrupting me.`);
        ImageClass.setImage(images.v5.VanessaRoom_50);
        vanessa.talk(`Go ahead, speak your mind.`);
    } else {

        mc.talk(`Can you let me talk for a second?`);
        ImageClass.setImage(images.v5.VanessaRoom_50);
        vanessa.talk(`I'm listening.`);
    }

    mc.talk(`Like I was saying, Ann and I were talking this morning.`);
    mc.talk(`And we could use your advice on how to take our relationship to the next level. Sex-wise.`);

    ImageClass.setImage(images.v5.VanessaRoom_48);
    vanessa.talk(`HAHA!`);
    mc.talk(`What?`);
    await vanessa.setQuestion(new Question({ text: `You sound like Ann. No way that was your idea.`, options: { think: false }, key: `v5admittedItWasAnnsIdea` })
        .option({ title: `It is my idea`, key: true })
        .option({ title: `It's Ann's idea`, key: false }));


    if (Question.globalAnswers.v5admittedItWasAnnsIdea) {
        await mc.set((properties) => {
            properties.liar--;
        });

        return jump(V5VanessaHouseMorningJoeStatusNot6_2McIdea, "V5VanessaHouseMorningJoeStatusNot6_2McIdea");
    } else {

        await mc.set((properties) => {
            properties.liar++;
        });

        return jump(V5VanessaHouseMorningJoeStatusNot6_2AnnIdea, "V5VanessaHouseMorningJoeStatusNot6_2AnnIdea");
    }

};
export const V5VanessaHouseMorningJoeStatusNot6_2McIdea = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_48);
    mc.talk(`It is my idea.`);
    vanessa.talk(`Haha, no way, I'm not buying it.`);
    mc.talk(`Why not?`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Because why would you need my help?`);
    vanessa.talk(`You are a guy, just point and stick.`);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {

        vanessa.talk(`Yesterday you didn't have a problem with that.`);
        mc.talk(`Fair point...`);
        vanessa.talk(`But I don't care about that now, I want to hear the juicy details.`);
    } else {

        mc.talk(`...`);
    }
    vanessa.talk(`Just admit it and it will be easier on the both of us.`);
    mc.talk(`Mmm... Do you promise to keep it between us?`);
    vanessa.talk(`I am good at keeping secrets.`);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {


        vanessa.talk(`And I don't need to prove it to you.`);
        vanessa.talk(`You fucked me while your best friend was passed out and I didn't say a word.`);
    }
    mc.talk(`Fine!`);
    vanessa.talk(`So... How can I help Ann?`);

    return jump(V5VanessaHouseMorningJoeStatusNot6_3, "V5VanessaHouseMorningJoeStatusNot6_3");
};

export const V5VanessaHouseMorningJoeStatusNot6_2AnnIdea = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_48);
    mc.talk(`It's Ann's idea.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Obviously.`);
    vanessa.talk(`So what does she want?`);
    return jump(V5VanessaHouseMorningJoeStatusNot6_3, "V5VanessaHouseMorningJoeStatusNot6_3");
};

export const V5VanessaHouseMorningJoeStatusNot6_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_50);

    mc.talk(`I believe she wants to have sex, but she is too afraid to do it.`);
    vanessa.talk(`Do you believe or she told you?`);
    mc.talk(`She told me.`);
    ImageClass.setImage(images.v5.VanessaRoom_48);
    vanessa.talk(`NAUGHTY ANN!`);
    ImageClass.setImage(images.v5.VanessaRoom_41);
    vanessa.talk(`What a bitch! Why didn't she talk to me about that?`);
    mc.talk(`Maybe because of the way you react?`);
    vanessa.talk(`Nonsense.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Tell her I have the perfect guide for her.`);
    vanessa.talk(`Write this down.`);
    vanessa.talk(`"Hey Ann, this is the steps you need to do, at least at the start."`);
    vanessa.talk(`Step one: Take off your clothes.`);
    vanessa.talk(`Step two: Open your legs.`);
    vanessa.talk(`Make sure to do this in that order otherwise it will be hard for you to take off your panties.`);

    vanessa.talk(`Did you get all of that?`);
    mc.talk(`I lost you at step one.`);
    mc.talk(`Ann was right, asking for your advice was a bad idea.`);

    ImageClass.setImage(images.v5.VanessaRoom_48);
    vanessa.talk(`OH MY GOD! I was joking!`);
    vanessa.talk(`Don't be surprised but I have a great plan on how to help her, and you.`);
    mc.talk(`I don't need any help.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Even if you don't, it's going to help you, trust me.`);
    mc.talk(`What's your plan?`);
    vanessa.talk(`Now now, don't be greedy.`);
    vanessa.talk(`I'll talk to her.`);
    mc.talk(`I'm not sure about this...`);
    vanessa.talk(`Relax! I've known her for a long time, everything will be alright.`);
    vanessa.talk(`I honestly want to help her.`);
    mc.talk(`That's nice of you...`);
    vanessa.talk(`Of course! What are friends for?`);
    mc.talk(`When it's about you, I am not sure.`);

    ImageClass.setImage(images.v5.VanessaRoom_49);
    vanessa.talk(`What's that supposed to mean?`);
    mc.talk(`Nothing.`);


    return jump(V5VanessaHouseMorningJoeStatusNot6_3Events, "V5VanessaHouseMorningJoeStatusNot6_3Events");
};
export const V5VanessaHouseMorningJoeStatusNot6_3Events = async (): Promise<any> => {

    ImageClass.setImage(images.v5.VanessaRoom_50);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
        mc.talk(`By the way, have you talked to Joey since yesterday?`);
        vanessa.talk(`No, I haven't. Why?`);
        mc.talk(`Does he suspect something?`);
        vanessa.talk(`Well, thanks to you, he was completely wasted, so I doubt it.`);
        if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "dontHurtJoey") {
            vanessa.talk(`You are really funny you know it?`);
            vanessa.talk(`At the coffee shop yesterday you told me not to hurt Joe, yet you fuck me behind his back.`);
            vanessa.talk(`Or right in front of him to be exact.`);
            mc.talk(`You started it, you sucked my dick while I was filming.`);
            vanessa.talk(`Are you complaining?\nI had a dick close to my face, what did you want me to do?`);
            mc.talk(`...`);
            vanessa.talk(`That's right.`);
        }
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            vanessa.talk(`That's twice by the way, I should start charging you for blowjobs.`);
            mc.talk(`I didn't ask for the second one, that was all you.`);
            vanessa.talk(`Are you complaining?`);
            mc.talk(`Not at all.`);
        }

        vanessa.talk(`Just don't be stupid and say something to him.`);
        mc.talk(`I'll try to keep my mouth shut.`);
        vanessa.talk(`Don't try, just do it!`);
    }
    if (Question.globalAnswers.v4ToldJoeyToTurnAround) {
        mc.talk(`And another thing, I still have no idea how you made him forgive you after he saw you dancing with that guy.`);
        vanessa.talk(`RIGHT! About that!`);
        ImageClass.setImage(images.v5.VanessaRoom_41);
        vanessa.talk(`You told him to turn around didn't you?`);
        mc.talk(`Maybe.`);
        vanessa.talk(`You must have.`);
        ImageClass.setImage(images.v5.VanessaRoom_49);
        mc.talk(`Why did you dance with him when you saw Joe was sitting so close by?`);
        ImageClass.setImage(images.v5.VanessaRoom_50);
        vanessa.talk(`Don't ask stupid questions. I was in a good mood. I felt like dancing and he was just there. No big deal.`);
        mc.talk(`You saw that Joey didn't appreciate it.`);
        vanessa.talk(`Because you told him. If he didn't see me he wouldn't have cared.`);
    } else if (Question.globalAnswers.v4ToldJoeyToTurnAround === false) {
        mc.talk(`By the way, I saw you in the restroom with the guy you were dancing with.`);
        ImageClass.setImage(images.v5.VanessaRoom_49);
        vanessa.talk(`Were you the one knocking on the door?`);
        mc.talk(`Yup.`);
        ImageClass.setImage(images.v5.VanessaRoom_50);
        vanessa.talk(`You know how people usually say they can explain their actions?`);
        mc.talk(`Yes.`);
        vanessa.talk(`So, I can't.`);
        vanessa.talk(`We were just dancing, then he got so dominant and pushed me to the restroom and told me to get down on my knees.`);
        vanessa.talk(`Guys like that should get what they demand.`);
        mc.talk(`Why don't you get down on your knees right now?`);
        ImageClass.setImage(images.v5.VanessaRoom_48);
        vanessa.talk(`Haha! Nice try.`);
    }

    ImageClass.setImage(images.v5.VanessaRoom_50);
    vanessa.talk(`Anyway. I need to get dressed and leave for work.`);
    ImageClass.setImage(images.v5.VanessaRoom_44);
    vanessa.talk(`The door is right over there.`);
    mc.talk(`Didn't you say your father might kill me on my way out?`);
    vanessa.talk(`He left already, the house is empty.`);
    mc.talk(`Bye Vanessa.`);

    return jump(V5VanessaHouseMorningJoeStatus6_4, "V5VanessaHouseMorningJoeStatus6_4");
};

export const V5VanessaHouseMorningJoeStatus6_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_47, { transition: true });
    await mc.setQuestion(new Question({ text: `She is getting dressed...`, options: { think: true }, key: `v5PeepOnVanessaRoom` })
        .option({ title: `Peep on her`, key: true })
        .option({ title: `Just leave`, key: false }));


    if (Question.globalAnswers.v5PeepOnVanessaRoom) {
        if (mc.properties.joeStatus === "enemy") {

            mc.think(`She said she doesn't mind when people look at her naked, so fuck it.`);
        }
        mc.think(`Time to see some boobies!`);
        ImageClass.setImage(images.v5.VanessaRoom_45);
        mc.think(`Shit.`);
        ImageClass.setImage(images.v5.VanessaRoom_46);
        vanessa.talk(`You are so predictable.`);
        mc.talk(`If I didn't open the door, how long would you be standing here?`);
        ImageClass.setImage(images.v5.VanessaRoom_47, { shake: true, duration: 0 });
        empty.think(`*SLAM*`);
        mc.think(`I never learn.`);
        mc.think(`Time to head home.`);
        return jump(V5HomeAfterVanessa, "V5HomeAfterVanessa");

    }

    return jump(V5HomeAfterVanessa, "V5HomeAfterVanessa");
};

export const V5VanessaHouseMorningJoeStatusNot6_2_Hate = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaRoom_37_2);
    mc.talk(`Have you heard from Ann?`);
    vanessa.talk(`I haven't, why?`);
    mc.talk(`Let's sit down.`);

    ImageClass.setImage(images.v5.VanessaRoom_41);
    vanessa.talk(`Why did you ask about her? You were the last one who saw her.`);


    ImageClass.setImage(images.v5.VanessaRoom_50);
    mc.talk(`She was with me at the bar but she left with Chris.`);

    vanessa.talk(`So? It's not like he is fucking her right now... She won't let him.`);
    mc.talk(`Are you sure about that?`);
    if (Game.seenScenarios.includes(`ClubEventJoeInsideAnnStatus1_2`)) {
        mc.talk(`I saw you two at the restroom...`);
        mc.talk(`I saw her taking that pill.`);
        vanessa.talk(`What were you doing at the girl's restroom anyway?`);
        mc.talk(`Just checking that everything was ok.`);
        mc.talk(`What did you give her?`);
        vanessa.talk(`Just something that will help her be less stressed out.`);
        vanessa.talk(`And it worked, until I left, I saw her smiling.`);
    } else {
        vanessa.talk(`Of course I'm sure.`);
        mc.talk(`If you say so...`);
    }

    ImageClass.setImage(images.v5.VanessaRoom_38);
    vanessa.talk(`Why are you so worried about her? I thought you don't give a fuck about her.`);
    ImageClass.setImage(images.v5.VanessaRoom_50);
    mc.talk(`I just told her I'm not attracted to her, but I can still care for her as a friend.`);

    mc.talk(`That's just how I am.`);
    vanessa.talk(`Well, have you tried calling her?`);
    mc.talk(`I sent her a text.`);
    vanessa.talk(`That's the same.`);

    return jump(V5VanessaHouseMorningJoeStatusNot6_3Events, "V5VanessaHouseMorningJoeStatusNot6_3Events");
};

export const V5HomeAfterVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (mc.properties.annStatus === "hate") {

        mc.think(`That wasn't very helpful...`);
    } else {

        mc.think(`I have no idea what Vanessa is planning.`);
        mc.think(`Knowing her, it must be something fucked up.`);
    }

    mc.think(`I don't have anything else to do... I'll spend some time on the computer.`);

    return jump(V5HomeAfterVanessaHome, "V5HomeAfterVanessaHome");
};


